import {
    AsYouType,
} from 'libphonenumber-js/max';
import {phoneCode} from '../../../sb-phone-codes/v1/sb-phone-codes-1.0.0';

export default class TelephoneLibphonenumberMask {
    telephone(value, country, withoutTrailingZero = false) {
        const countryUppercase = country.toUpperCase();
        const countryCode = withoutTrailingZero ? '+' + phoneCode(country) : '';

        let asYouType = new AsYouType();
        asYouType.defaultCountry = countryUppercase;
        asYouType.reset();
        asYouType.input(countryCode + value);

        let maskTemplate = asYouType.getTemplate();
        maskTemplate = maskTemplate.replaceAll('(', '');
        maskTemplate = maskTemplate.replaceAll(')', '');
        maskTemplate = maskTemplate.replaceAll('x', '9');
        maskTemplate = maskTemplate.slice(countryCode.length).trim();

        return maskTemplate;
    }
}
